export const buyers = [
  { name: 'Valentina R.', country: 'Colombia', minutesAgo: 2 },
  { name: 'Lucía M.', country: 'Argentina', minutesAgo: 4 },
  { name: 'Camila G.', country: 'Chile', minutesAgo: 1 },
  { name: 'Sofía H.', country: 'México', minutesAgo: 6 },
  { name: 'Daniela P.', country: 'Perú', minutesAgo: 3 },
  { name: 'Mariana L.', country: 'España', minutesAgo: 8 },
  { name: 'Andrea C.', country: 'Uruguay', minutesAgo: 5 },
  { name: 'Gabriela T.', country: 'Ecuador', minutesAgo: 2 },
  { name: 'Paula S.', country: 'Costa Rica', minutesAgo: 7 },
  { name: 'Natalia V.', country: 'Puerto Rico', minutesAgo: 3 },
  { name: 'Fernanda A.', country: 'Guatemala', minutesAgo: 9 },
  { name: 'Isabella O.', country: 'Panamá', minutesAgo: 4 },
  { name: 'Carolina D.', country: 'República Dominicana', minutesAgo: 1 },
  { name: 'Ximena B.', country: 'Bolivia', minutesAgo: 6 },
  { name: 'Renata F.', country: 'Paraguay', minutesAgo: 5 },
];
